export enum AccessibleRoles {
    tablist = 'tablist',
}
